import { Box } from '@mui/material';
import { CreditReportGridData } from './CreditReportGridData';
import { IInquiries } from './interfaces/interfaces';

export const Inquiry = ({ inquiries }: IInquiries) => (
  <Box marginBottom={2}>
    <CreditReportGridData tableName="Inquiries" data={inquiries} />
  </Box>
);
